import React from 'react';
import { Navigate } from 'react-router-dom';
import { getCurrentAppType } from 'utils/dynamicConfig';

interface ConditionalRouteProps {
  children: React.ReactNode;
  requireOpsTools?: boolean;
  requireOrderManagement?: boolean;
  fallbackPath?: string;
}

const ConditionalRoute: React.FC<ConditionalRouteProps> = ({
  children,
  requireOpsTools = false,
  requireOrderManagement = false,
  fallbackPath = '/ops-tools'
}) => {
  const appType = getCurrentAppType();
  const isOpsDomain = appType.includes('ops');

  // If route requires Ops tools and user is not on Ops domain, redirect
  if (requireOpsTools && !isOpsDomain) {
    return <Navigate to="/orders" replace />;
  }

  // If route requires Order Management access and user is on Ops domain, redirect
  if (requireOrderManagement && isOpsDomain) {
    return <Navigate to={fallbackPath} replace />;
  }

  return <>{children}</>;
};

export default ConditionalRoute; 